/* eslint-disable indent */
import { USER_APPLICATIONS_DOCUMENT_ANALYZE_URL } from '../../constants';
import noticeError from '../../utils/errors/noticeError';
import { api } from './API';

/**
 * API class for document analysis operations
 */
class RequiredDocumentAPI {
  /**
   * Analyze a document by its ID
   * @param {string} documentId - The ID of the document to analyze
   * @returns {Promise<any>} - The analysis result
   */
  async analyzeDocument(documentId: string, isDraft = false) {
    try {
      const base = USER_APPLICATIONS_DOCUMENT_ANALYZE_URL.replace(
        ':id',
        documentId
      );
      const url = isDraft ? `${base}?isDraft=true` : base;
      const response = await api().post(url);
      return response.data;
    } catch (error) {
      noticeError(error);
      console.error(error);
    }
  }
}

export default new RequiredDocumentAPI();
